import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // for selectable
import { FullCalendarComponent } from '@fullcalendar/angular';

interface EventCalendar {
  title: string;
  date: string;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
}

@Component({
  selector: 'control-fullcalendar',
  templateUrl: './control-fullcalendar.component.html',
  styleUrls: ['./control-fullcalendar.component.scss']
})
export class ControlFullCalendarComponent implements OnInit {

  @Input() sfcontrol : SpecialFormControl;

  @Input('events') events: string

  @Output('blurAction') _blurAction: EventEmitter<any> = new EventEmitter();
  @Output('enterKey') _enterKey: EventEmitter<any> = new EventEmitter();
  @Output('BlockedDaysArray') BlockedDaysArray: EventEmitter<any> = new EventEmitter();
  hidden
  myControl

  @ViewChild('calendar', {static: false}) controlCalendar: FullCalendarComponent;

  public calendarEvents: EventCalendar[] = [];
  
  calendarPlugins = [dayGridPlugin, interactionPlugin];
  calendarOptions = {
    defaultView: 'dayGridMonth',
    selectable: true,
    selectMirror: true,
    editable: true,
    header: {
      right: 'prevYear,prev,next,nextYear,today',
      center: 'title',
      left: 'dayGridMonth'
    },
  }

  constructor() { 

  }

  ngOnInit() { 
    this.hidden=true;
    this.cleanCalendar();
   
    this.assignInitialValue(this.sfcontrol.value);

    this.sfcontrol.valueChanges
      .pipe(
        //take(1) 
      ).subscribe( value => this.assignInitialValue(value) );

  }

  handleDateClick(e){
    
    let myEvents: EventCalendar[] = [];
    const eventName = 'BLOQUEADO';
    const eventDate = e.dateStr;
    const currentEvent = this.calendarEvents.find( i => i.date === eventDate );
    if (currentEvent) {
      myEvents =  this.calendarEvents.filter( i => i.date !== eventDate);  
    } else {
      myEvents = [...this.calendarEvents];
      const myEvent = { title: eventName, date: eventDate };
      myEvents.push( myEvent );
    }

    this.calendarEvents = [...myEvents];

    this.updateControl(myEvents);
    
  }

  assignInitialValue(value: string): void {
    let input = value as string;
    const data: string[] = input ? input.split('#') : [];

    const convertedData: EventCalendar[] = data.map( i => {
      
      if ( i.includes('{') ) {
        // CONVERTIR EL CALENDARIO EN SOLO LECTURA
        const objectExt = JSON.parse(i);

        return { 
          title: objectExt['name'], 
          date: objectExt['date'], 
          backgroundColor: objectExt['color'], 
          borderColor: 'blue',
          textColor: 'darkblue' 
        };
      } else {
        return { title: 'BLOQUEADO', date: i };  
      }
      
    } );

    this.calendarEvents = [...convertedData];

  }


  cleanCalendar(){
    this.calendarEvents=[]
    this.BlockedDaysArray ?
    this.BlockedDaysArray.emit("Limpiar") :
    null;
  }
  

  private updateControl( dataCalentar: EventCalendar[]  ): void {
    const days = dataCalentar.length > 0 ? dataCalentar.map( i => i.date).join('#') : '';

    this.sfcontrol.markAsDirty();
    this.sfcontrol.setValue( days );

  }

  public eventoReder(evento: any) {

  }

  public diaRender(evento: any) {

  }

}


